<template>
    <div>
        <div
            v-if="showErrorNotification"
            class="center margin-vertical-20">
            <div class="note note--error">
                <p>
                    {{ trans('SEARCH_GLOBALDATA_ERROR_TEXT') }}
                </p>
            </div>
        </div>
        <div
            v-if="showNoResultsNotification"
            class="center margin-vertical-20">
            <div class="note note--info">
                <p>
                    {{ trans('SEARCH_NO_RESULTS_TEXT') }}
                </p>
            </div>
        </div>
        <div
            v-if="loadingResults"
            class="center">
            <img
                :src="getCdnLink('img/preloaders/preloader.gif')"
                width="20"
                height="20"
                alt=""
                class="margin-bottom-20" />
        </div>
        <ul class="list list--blank">
            <li
                v-for="item in slicedItems"
                :key="item.ReportId"
                class="list__item pos-relative">
                <!-- LINK -->
                <div class="list__itemWrap list__itemWrap--noHover text--linkReset padding-vertical-15">
                    <i class="list__itemIcon float-left">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 26 26"
                            width="26"
                            height="26">
                            <use href="#globalDataIcon" />
                        </svg>
                    </i>

                    <div class="list__itemText width70">
                        <h2 class="h5 margin-bottom-0 text-ellipsis text-semibold">
                            <!-- Headline -->
                            {{ item.Title }}
                        </h2>
                        <h3 class="font-size-s text-ellipsis">
                            <!-- Subline -->
                            <span>{{ item.ReportType }}</span> | {{ item.Description }}
                        </h3>
                    </div>
                    <div class="width25 buttonGroup display-flex flex--justifyContent-end">
                        <!-- PDF -->
                        <a
                            v-if="item.ReportPdfFileName"
                            :href="getLink(item.ReportPdfFileName)"
                            target="_blank"
                            referrerpolicy="unsafe-url"
                            class="button"
                            :title="trans('DOWNLOAD_PDF_TEXT')">
                            <span class="sprite fileIcon__pdf"></span>
                        </a>
                        <span
                            v-else
                            class="button button--disabled">
                            <span class="sprite fileIcon__pdf--disabled"></span>
                        </span>
                        <!-- XLS -->
                        <a
                            v-if="item.ReportXslFileName"
                            :href="getLink(item.ReportXslFileName)"
                            target="_blank"
                            referrerpolicy="unsafe-url"
                            class="button"
                            :title="trans('DOWNLOAD_XLS_TEXT')">
                            <span class="sprite fileIcon__xls"></span>
                        </a>
                        <span
                            v-else
                            class="button button--disabled">
                            <span class="sprite fileIcon__xls--disabled"></span>
                        </span>
                        <!-- PPT -->
                        <a
                            v-if="item.ReportPptFileName"
                            :href="getLink(item.ReportPptFileName)"
                            target="_blank"
                            referrerpolicy="unsafe-url"
                            class="button"
                            :title="trans('DOWNLOAD_PPT_TEXT')">
                            <span class="sprite fileIcon__ppt"></span>
                        </a>
                        <span
                            v-else
                            class="button button--disabled">
                            <span class="sprite fileIcon__ppt--disabled"></span>
                        </span>
                        <!-- Page -->
                        <a
                            :href="getLink(detailViewPrefix + item.UrlNode)"
                            target="_blank"
                            referrerpolicy="unsafe-url"
                            class="button">
                            <i
                                class="fa fa-globe"
                                aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
    import Vue from 'vue';
    import axios from 'axios';
    import { getCdnLink } from 'tools/getCdnLink';
    import { getFromTemplate, getPath } from 'tools/getFromHtml';
    import Translator from 'tools/trans';

    const API_KEY = getFromTemplate('var', 'globalDataApiKey');
    const REPORT_ROUTE = getPath('globalDataReportRoute');
    const REFERRER_ROUTE = getPath('globalDataReferrerRoute');
    const NEEDLE = 'globaldata.com/';
    const DETAIL_VIEW_PREFIX_URL = '/Analysis/details/';

    const RESULT_FETCH_STARTING_DELAY_MILISECONDS = 10;

    export default Vue.component('GlobalDataSearch', {
        name: 'GlobalDataSearch',
        props: {
            limit: {
                type: Number,
                default: 20,
            },
            searchQuery: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                resultItems: [],
                updateInProgress: false,
                loadingResults: false,
                showErrorNotification: false,
                showNoResultsNotification: false,
                detailViewPrefix: DETAIL_VIEW_PREFIX_URL,
            };
        },
        computed: {
            slicedItems() {
                return this.resultItems.slice(0, this.limit);
            },
        },
        methods: {
            trans: Translator.trans,
            getCdnLink,
            updateSearchResults() {
                this.updateInProgress = true;
                setTimeout(() => {
                    if (this.updateInProgress) {
                        this.updateInProgress = false;
                        this.loadingResults = true;
                        this.showNoResultsNotification = false;
                        this.showErrorNotification = false;
                        const query = {
                            'TokenID': API_KEY,
                            'PageNumber': 1,
                            'title': this.searchQuery,
                        };
                        const url = REPORT_ROUTE;
                        axios.get(url, {
                            timeout: 5000,
                            params: query,
                        }).then(response => {
                            this.loadingResults = false;
                            this.showErrorNotification = false;
                            this.resultItems = response.data['Records'];
                            if (this.resultItems.length === 0) {
                                this.showNoResultsNotification = true;
                            }
                        }).catch(error => {
                            this.loadingResults = false;
                            this.showErrorNotification = true;
                            console.error(error);
                        });
                    }
                }, RESULT_FETCH_STARTING_DELAY_MILISECONDS);
            },
            getLink(link) {
                return REFERRER_ROUTE + this.getRelativePath(link);
            },
            getRelativePath(path) {
                if (path && path.indexOf(NEEDLE) > -1) {
                    return path.substring(path.indexOf(NEEDLE) + NEEDLE.length);
                }

                return path;
            },
        },
        mounted() {
            this.updateSearchResults();
        },
    });
</script>
